import { z } from 'zod';

const uuidSchema = z.string().uuid();

export const optionalUuidSchema = (fieldName: string) =>
  z
    .string()
    .trim()
    .refine((value) => value === '' || uuidSchema.safeParse(value).success, `${fieldName} must be a valid UUID`);

export const PERCENT_PATTERN = /^\d+(\.\d{1,2})?$/;

export const percentFieldSchema = (label: string) =>
  z
    .string()
    .min(1, `${label} is required`)
    .regex(PERCENT_PATTERN, `${label} must be a percent with at most two decimals`)
    .refine((val) => parseFloat(val) >= 0 && parseFloat(val) <= 100, `${label} must be between 0 and 100`);

export const percentStringToRate = (percent: string): number => {
  const [whole, fraction = ''] = percent.split('.');
  const digits = `${whole}${fraction}`;

  const shifted =
    whole.length > 2
      ? `${digits.slice(0, whole.length - 2)}.${digits.slice(whole.length - 2)}`
      : `0.${'0'.repeat(2 - whole.length)}${digits}`;

  return parseFloat(shifted);
};

export const billingDaySchema = (label: string) =>
  z
    .string()
    .regex(/^\d+$/, `${label} must be a whole number`)
    .refine((value) => Number(value) >= 1 && Number(value) <= 28, `${label} must be between 1 and 28`);
